import { defineComponent as _defineComponent } from 'vue';
import { ref, reactive, onMounted } from 'vue';
import { useAdaClasses } from './ada-classes';
const isBrowserIE = false;
const isBrowserEdge = false;
export default /*@__PURE__*/ _defineComponent({
    __name: 'A11yModalInner',
    emits: ['needsClose'],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const emit = __emit;
        function close() {
            emit('needsClose');
        }
        // TODO: Set these dynamically if (and only if) needed
        const { adaClasses, setAdaClasses } = useAdaClasses();
        const firstFocusEl = ref(null);
        const lastFocusEl = ref(null);
        onMounted(() => {
            firstFocusEl.value?.focus();
        });
        function tabLoopBackward() {
            lastFocusEl.value?.focus();
        }
        function tabLoopForward() {
            firstFocusEl.value?.focus();
        }
        // NOTE: Adapted from Angular opt-in-accessibility-modal.ts
        const adaStages = reactive({ 'AdaCursorState': 0, 'AdaContrastState': 0, 'AdaBiggerTextState': 0, 'AdaDesaturateState': 0, 'AdaHighlightLinksState': 0, 'AdaFontsState': 0, 'AdaZoomState': 0 });
        const adaStates = {
            'AdaCursorState': ['', 'ada-cursor'],
            'AdaContrastState': ['', 'ada-contrast'],
            'AdaBiggerTextState': ['', 'ada-bigger-text-1', 'ada-bigger-text-2', 'ada-bigger-text-3'],
            'AdaDesaturateState': ['', 'ada-desaturate'],
            'AdaHighlightLinksState': ['', 'ada-highlight-links'],
            'AdaFontsState': ['', 'ada-fonts'],
            'AdaZoomState': ['', 'ada-zoom'],
        };
        restoreAdaStages();
        const bigCursor = () => updateAdaStage('AdaCursorState', 1);
        const contrast = () => updateAdaStage('AdaContrastState', 1);
        const biggerText = () => updateAdaStage('AdaBiggerTextState', 3);
        const desaturate = () => updateAdaStage('AdaDesaturateState', 1);
        const highlightLinks = () => updateAdaStage('AdaHighlightLinksState', 1);
        const legibleFonts = () => updateAdaStage('AdaFontsState', 1);
        const zoom = () => updateAdaStage('AdaZoomState', 1);
        function updateAdaStage(adaStage, stageCount) {
            let stage = parseInt(localStorage.getItem(adaStage) || '') || 0;
            adaStages[adaStage] = stage == stageCount ? 0 : stage + 1;
            localStorage.setItem(adaStage, adaStages[adaStage]);
            updateAdaClasses();
        }
        function updateAdaClasses() {
            const newAdaClasses = Object.keys(adaStates)
                .map(key => adaStates[key][adaStages[key]])
                .filter(className => !!className);
            setAdaClasses(newAdaClasses);
        }
        function clearSettings() {
            Object.keys(adaStates).forEach(key => {
                adaStages[key] = 0;
                localStorage.setItem(key, adaStages[key]);
            });
            updateAdaClasses();
        }
        function restoreAdaStages() {
            restoreAdaStage('AdaCursorState');
            restoreAdaStage('AdaContrastState');
            restoreAdaStage('AdaBiggerTextState');
            restoreAdaStage('AdaDesaturateState');
            restoreAdaStage('AdaHighlightLinksState');
            restoreAdaStage('AdaFontsState');
            restoreAdaStage('AdaZoomState');
        }
        function restoreAdaStage(adaStage) {
            adaStages[adaStage] = parseInt(localStorage.getItem(adaStage) || '') || 0;
        }
        const __returned__ = { emit, close, isBrowserIE, isBrowserEdge, adaClasses, setAdaClasses, firstFocusEl, lastFocusEl, tabLoopBackward, tabLoopForward, adaStages, adaStates, bigCursor, contrast, biggerText, desaturate, highlightLinks, legibleFonts, zoom, updateAdaStage, updateAdaClasses, clearSettings, restoreAdaStages, restoreAdaStage };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
